// extracted by mini-css-extract-plugin
export default {"imageArea":"style_imageArea__MbWqx","imageArea__img":"style_imageArea__img__3cQcF","imageArea__text":"style_imageArea__text__lFlKH"};